import { stripHtml as stripHtmlLib } from "string-strip-html";

export function stripHtml(stringToStrip: string | undefined | null): string {
  return stringToStrip ? stripHtmlLib(stringToStrip).result : "";
}
